<template>
  <div class="grid grid-cols-2 gap-4">
    <BaseCard
      v-for="(card, index) in numberCards"
      :key="index"
      :heading="card.heading"
      :paragraph="card.paragraph"
      type="number"
      :class="{ 'col-span-2': spanFirstCard(index) }"
    />
  </div>
</template>

<script>
import BaseCard from '~/components/V2/Base/BaseCard/BaseCard.vue'

export default {
  components: {
    BaseCard
  },
  props: {
    numberCards: {
      type: Array,
      required: true
    }
  },
  methods: {
    spanFirstCard(index) {
      return !index && [1, 3].includes(this.numberCards.length)
    }
  }
}
</script>
